<script setup lang="ts">
const emit = defineEmits<{
  regenerate: [];
  close: [];
}>();
</script>

<template>
  <div class="regenerate-banner">
    <div class="message">
      <div class="c-title-bold--m">発想のヒントを再生成する</div>
      <div class="c-text-regular--m">
        業務情報を更新したことで、発想のヒントを再生成できます。
      </div>
    </div>
    <div class="actions">
      <button
        class="c-btn c-btn--small c-btn--auto c-outlineBtn"
        @click="emit('close')"
      >
        閉じる
      </button>
      <button
        class="c-btn c-btn--small c-btn--auto c-btn--AnewsPrimary"
        @click="emit('regenerate')"
      >
        再生成する
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.regenerate-banner {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  justify-content: space-between;
  padding: 16px;
  border: 1px solid $color-gray400;
  border-radius: 4px;

  .actions {
    display: flex;
    gap: 8px;
    flex-shrink: 0;
  }
}
</style>
